<template>
  <router-link class="icon-mypage" :to="to">
    <img class="icon" v-if="src" :src="src" height="100%" />
  </router-link>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    /** 画像のソース */
    src: {
      type: String,
      required: true,
    },
    to: {
      type: Object,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.icon-mypage {
  margin: $margin-s;
  height: 24px;
}
.icon {
  border-radius: var(--radius-circle);
}
</style>
